import { AfterContentChecked, Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { TableColumnType } from "src/app/constants/table";

import { MemberSearchResult } from "src/app/models/member-lookup";
import { TableColumn } from "src/app/models/table";

@Component({
    selector: 'mwp-member-members-grid',
    templateUrl: './members-grid.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MemberSearchGridComponent implements OnInit, AfterContentChecked {
    @Input() public header: string;
    @Input() public subheader: string;
    @Input() public isSSNTable: boolean = true;
    @Input() public members: MemberSearchResult[];
    @Output() public emitSelectedMember: EventEmitter<MemberSearchResult> = new EventEmitter();

    public membersMatTableData: MatTableDataSource<MemberSearchResult>;
    public membersSSNColumns: TableColumn[] = [
        {
            columnName: 'Name',
            propertyId: 'memberName',
            columnType: TableColumnType.hyperLink,
            dataTypePropertyId: 'memberName',
            isEmit: true,
        },
        {
            columnName: 'Company',
            propertyId: 'companyName',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Last 4 SSN',
            propertyId: 'ssn',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'System ID',
            propertyId: 'systemNumber',
            columnType: TableColumnType.label,
        },
    ];

    constructor() {
    }

    ngOnInit(): void {
        this.loadMatTable();
    }

    ngAfterContentChecked(): void {
        if (this.membersMatTableData.data != this.members)
            this.loadMatTable();
    }

    private loadMatTable(): void {
        this.membersMatTableData = new MatTableDataSource<MemberSearchResult>();
        this.membersMatTableData.data = this.members;
    }

    public selectMember(event: MemberSearchResult): void {
        this.emitSelectedMember.emit(event);
    }
}